import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { QueryParam } from '../query-param';

@Injectable({
  providedIn: 'root'
})
export class ApiService {



  portalId = ["447", "426", "273"];
  billerName = ["COMVIVA"];
  operator = ["2068", "2029"];
  serviceIds = ["1209", "1210", "1211", "12012"]

  redirectIdsForCOMVIVA = ["426", "273", "COMVIVA"]

  public isPortalIdPresent(id: any) {
    return this.portalId.includes(id)
  }

  public isBillerNamePresent(name: any) {
    return this.billerName.includes(name)
  }

  public isOperatorPresent(id: any) {
    return this.operator.includes(id)
  }

  public checkForMobileLogin(portalId: any, billerName: any, operatorId: any) {
    // debugger;
    if (this.isPortalIdPresent(portalId) && this.isBillerNamePresent(billerName) && this.isOperatorPresent(operatorId)) {
      return true;
    } else {
      return false;
    }

  }


  public isRedirct(portalId: any, biller: any) {

    return this.redirectIdsForCOMVIVA.includes(portalId) && this.redirectIdsForCOMVIVA.includes(biller);
  }



  getMobileResponseFORCOMVIVA447(url: any) {
    return this.http
      .post(this.url + "/mobixne/getComvivaFormobile", url, { responseType: 'text' })
      .pipe(map(results => results));
  }

  unSubMobileResponseFORCOMVIVA447(url: any) {
    return this.http
      .post(this.url + "/mobixne/unSubComvivaFormobile", url)
      .pipe(map(results => results));
  }

  getSubDataByID(msisdn: any, serviceid: any) {
    return this.http
      .get(this.url_427 + "/getSubDataById?msisdn=" + msisdn + "&serviceid=" + serviceid)
      .pipe(map(results => results));
  }



  url = 'http://103.127.31.206:8081/wap';
  sslapi = 'https://technov.org/wap';
  url_427 = 'https://wap.matrixads.in/mglobopay';
  url_tiara = 'http://web.tiaradigital.in/billingPay'

  newUrl = 'http://103.127.157.215:8080';


  // url1 = 'http://localhost:8081/wap';
  //  url = 'http://localhost:8081/wap'; 


  //  url = 'http://localhost:8081/wap';


  unSubscribedMOBIXONE(queryParam: QueryParam) {
    return this.http
      .post(this.sslapi + "/mobixne", queryParam)
      .pipe(map(results => results));
  }

  unSubscribedMobixOne427(url: any) {
    return this.http
      .get(this.url_427 + "/genericUnsub")
      .pipe(map(results => results));
  }

  unSubscribedtrendy(url: string) {
    return this.http.get(url).pipe(map(results => results));
  }
  


  getMobilePINResponse(url: any) {
    return this.http
      .get(url)
      .pipe(map(results => results));
  }

  getMenus(menuList: any, lang: any) {
    return this.http
      .post(this.sslapi + "/menu/" + lang, menuList)
      .pipe(map(results => results));
  }

  cancelPinSubscriptionForTpay(pin: any, msisdn: any, operatorCode: any, portalId: any) {
    return this.http
      .get("http://wap.globocom.info/mglobopay/verifyCancelPinSubscriptionForTpay/" + pin + "/" + msisdn + "/" + operatorCode + "/" + portalId)
      .pipe(map(results => results));
  }

  getMobileResponse(url: any) {
    return this.http
      .get(url)
      .pipe(map(results => results));
  }

  unSubscribed(mobileNumber: any) {
    return this.http
      .get("http://103.127.157.215:8080/mglobopay/qanawatKSAUnsub?msisdn=" + mobileNumber)
      .pipe(map(results => results));
  }

  unSubscribedTpayService(msisdn: any, operatorCode: any, portalId: any) {
    return this.http
      .get("http://wap.globocom.info/mglobopay/cancelationSubscriptionPinSmsForTpay/" + msisdn + "/" + operatorCode + "/" + portalId)
      .pipe(map(results => results));
  }

  unSubscribedTpayServiceFor6(msisdn: any) {
    return this.http
      .get("http://wap.matrixads.in/mglobopay/CheckSubscriptionStatusGamesWorld?msisdn=" + msisdn)
      .pipe(map(results => results));
  }



  // main = "https://mocki.io/v1/049d5512-d999-4fed-a126-ff0d99e3322d"
  // urls =  "https://mocki.io/v1/270db866-718c-4ac5-9946-c7c7439b7fc6";

  //url = 'http://localhost:8081/wap';


  url1 = 'http://localhost:8081/wap';

  public item: any;

  constructor(private http: HttpClient) { }

  getConfigData(data: any, lang: any, theme: any) {
    return this.http
      .get(this.sslapi + '/config/' + data + '/' + lang + '/' + theme)
      .pipe(map(results => results));
  }

  getAccount(data: any, lang: any) {
    return this.http
      .get(this.sslapi + '/account/' + data + '/' + lang)
      .pipe(map(results => results));
  }

  getOperatorCode(id: string) {
    return this.http
      .get(this.sslapi + '/operatorId/' + id)
      .pipe(map(results => results));
  }

  getConfigNav(lang: any) {
    return this.http
      .get(this.sslapi + '/config/config_nav/' + lang)
      .pipe(map(results => results));
  }

  getTCData(data: any, lang: any) {
    return this.http
      .get(this.sslapi + '/tc/' + data + '/' + lang)
      .pipe(map(results => results));
  }

  getFAQData(data: any, lang: any) {
    return this.http
      .get(this.sslapi + '/faq/' + data + '/' + lang)
      .pipe(map(results => results));
  }

  getAboutUsData(data: any, lang: any) {
    return this.http
      .get(this.sslapi + '/aboutus/' + data + '/' + lang)
      .pipe(map(results => results));
  }

  getData(data: any) {
    return this.http
      .get(this.sslapi + this.mapUrlParam(data))
      .pipe(map(results => results));
  }

  getCats(data: any) {
    return this.http.get(this.sslapi + data).pipe(map(results => results));
  }

  public setItem(item: any) {
    this.item = item;
  }

  public getItem() {
    return this.item;
  }


  public mapRequestParam(queryParam: any) {
    let str = '/?';
    if (queryParam.id != undefined && queryParam.id != null) {
      str = str + 'id=' + queryParam.id;
    }
    if (queryParam.lang != undefined && queryParam.lang != null) {
      str = str + '&lang=' + queryParam.lang;
    }
    if (
      queryParam.categoryid != undefined &&
      queryParam.categoryid != null
    ) {
      str = str + '&categoryid=' + queryParam.categoryid;
    }
    if (
      queryParam.operator != undefined &&
      queryParam.operator != null
    ) {
      str = str + '&operator=' + queryParam.operator;
    }
    if (queryParam.biller != undefined && queryParam.biller != null) {
      str = str + '&biller=' + queryParam.biller;
    }
    if (queryParam.theme != undefined && queryParam.theme != null) {
      str = str + '&theme=' + queryParam.theme;
    }
    if (queryParam.msisdn != undefined && queryParam.msisdn != null) {
      str = str + '&msisdn=' + queryParam.msisdn;
    }
    if (queryParam.country != undefined && queryParam.country != null) {
      str = str + '&country=' + queryParam.country;
    }
    if (queryParam.cid != undefined && queryParam.cid != null) {
      str = str + '&cid=' + queryParam.cid;
    }
    if (queryParam.code != undefined && queryParam.code != null) {
      str = str + '&code=' + queryParam.code;
    }


    if (queryParam.msisdn != undefined && queryParam.msisdn != null) {
      str = str + '&mobileNumber=' + queryParam.msisdn;
    }



    if (queryParam.request_ref != undefined && queryParam.request_ref != null) {
      str = str + '&request_ref=' + queryParam.request_ref;
    }

    if (queryParam.status != undefined && queryParam.status != null) {
      str = str + '&status=' + queryParam.status;
    }

    if (queryParam.subscription_id != undefined && queryParam.subscription_id != null) {
      str = str + '&subscription_id=' + queryParam.subscription_id;
    }

    if (queryParam.operator_name != undefined && queryParam.operator_name != null) {
      str = str + '&operator_name=' + queryParam.operator_name;
    }

    return str;
  }

  public mapUrlParam(data: any) {
    let str = '/?';
    if (data.id != undefined && data.id != null && data.id != 0) {
      str = str + 'id=' + data.id;
    }
    if (data.lang != undefined && data.lang != null) {
      str = str + '&lang=' + data.lang;
    }
    if (
      data.categoryid != undefined &&
      data.categoryid != null &&
      data.categoryid != 0
    ) {
      str = str + '&categoryid=' + data.categoryid;
    }

    if (
      data.operator != undefined &&
      data.operator != null &&
      data.operator != 0
    ) {
      str = str + '&operator=' + data.operator;
    }
    if (data.biller != undefined && data.biller != null) {
      str = str + '&biller=' + data.biller;
    }

    if (data.theme != undefined && data.theme != null && data.theme != 0) {
      str = str + '&theme=' + data.theme;
    }
    if (data.msisdn != undefined && data.msisdn != null) {
      str = str + '&msisdn=' + encodeURIComponent(data.msisdn);
    }
    if (data.country != undefined && data.country != null) {
      str = str + '&country=' + data.country;
    }
    if (data.cid != undefined && data.cid != null) {
      str = str + '&cid=' + data.cid;
    }

    if (data.code != undefined && data.code != null) {
      str = str + '&code=' + data.code;
    }

    return str;
  }


  getSubDataByServiceId(serviceid: any, msisdn: any) {
    return this.http.get(this.newUrl + '/mglobopay/getSubDataById?serviceid=' + serviceid + '&msisdn=' + msisdn).pipe(map(results => results))
  }


  getGenericUnsub(serviceid: any, msisdn: any) {
    return this.http.get(this.newUrl + '/mglobopay/genericUnsub?serviceid=' + serviceid + '&msisdn=' + msisdn).pipe(map(results => results))
  }

  getGenericUnsub2(serviceid: any, msisdn: any, subscription_id: any, requestRef: any) {
    return this.http.get(this.url_427 + '/genericUnsub?serviceId=' + serviceid + '&msisdn=' + msisdn + '&subscription_id=' + subscription_id + '&requestRef=' + requestRef).pipe(map(results => results))
  }

  getGenericUnsub4(serviceid: any, msisdn: any) {
    return this.http.get(this.url_427 + '/genericUnsub?serviceId=' + serviceid + '&msisdn=' + msisdn).pipe(map(results => results))
  }

  getGenericUnsub3(msisdn: any, serviceId: any, subscription_id: any, requestRef: any) {
    return this.http.get(this.url_427 + '/genericRedirect?msisdn=' + msisdn + '&serviceId=' + serviceId + '&subscription_id=' + subscription_id + '&requestRef=' + requestRef).pipe(map(results => results))
  }
  getGenericUnsub5(msisdn: any, serviceId: any, product_id: any) {
    return this.http.get(this.url_427 + '/genericUnsub?msisdn=' + msisdn + '&serviceId=' + serviceId + '&product_id=' + product_id).pipe(map(results => results))
  }

  unsubTiara(msisdn: any, serviceId: any) {
    return this.http.get(this.url_tiara + '/genericUnsub?msisdn=' + msisdn + '&serviceId=' + serviceId).pipe(map(results => results))
  }

  getHomeCompService(mob_no?: any) {
    return this.http.get(this.url_427 + '/qanawatKSAPortalValidation/' + mob_no).pipe(map(results => results))
  }

  checkSubscriptionStatus(mob_no?: any) {
    return this.http.get(this.url_427 + '/altrusCheckSubscriptionStatus?msisdn=' + mob_no).pipe(map(results => results))
  }
}
